<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">ほげ</h2>
        <v-form ref='userProfileForm'>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="user.name"
                class="mb-3"
                label="名前（表示名）"
                style="width: 300px"
                required
                :rules="[presenceValidation]"
              >
                <template v-slot:label>
                  <InputLabel labelName="名前（表示名）" :required="true" />
                </template>
              </v-text-field>
              <v-text-field
                v-model="user.position"
                class="mb-3"
                label="肩書き等"
                style="width: 300px"
              />
              <v-textarea
                v-model="user.introduction"
                class="mb-3"
                label="自己紹介・経歴・実績"
              />
              <div>
                <ImageFormAndThumbnail
                  label-name='プロフィール画像'
                  :propsImagePreviewURL='user.avatar.url'
                  @change-image-file="(value) => user.avatar = value"
                ></ImageFormAndThumbnail>
              </div>
              <profile-links-form
                :profileLinks="user.profileLinks"
                :destroyProfileLinks="destroyProfileLinks"
                ref='profileLinksForm'
              />
            </v-col>
          </v-row>
          <v-btn
            color="green darken-1"
            tile
            dark
            depressed
            @click="updateProfile"
          >
            更新
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import axios from 'axios'
import ProfileLinksForm from '@/components/commons/ProfileLinksForm'
import snakecaseKeys from 'snakecase-keys'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    ProfileLinksForm,
    ImageFormAndThumbnail,
    InputLabel
  },
  mixins: [headUtilsMixin, formValidationUtils],
  data: () => {
    return {
      pageTitle: 'プロフィール設定',
      user: {},
      allowedKeys: [
        'name',
        'avatar',
        'position',
        'introduction',
        'profileLinks'
      ],
      destroyProfileLinks: []
    }
  },
  mounted: function () {
    axios.get('/api/current_user_reference').then(
      ({ data }) => {
        const user = data.data.attributes
        this.user = this.filterUserObject(user, this.allowedKeys)
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `ユーザー情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload, {
          root: true
        })
      }
    )
  },
  methods: {
    updateProfile () {
      if (!this.$refs.userProfileForm.validate() || !this.$refs.profileLinksForm.validate()) return false

      const user = this.user
      let formData = new FormData()
      Object.keys(user).forEach((key) => {
        if (user[key] !== null) {
          formData.append(`user[${key}]`, user[key])
        }
      })
      const sendProfileLinks = this.user.profileLinks.concat(
        this.destroyProfileLinks
      )
      let arr = snakecaseKeys(sendProfileLinks)
      arr = arr.map(obj => {
        const {_destroy, ...rest} = obj
        return {_destroy: obj.destroy, ...rest}
      })
      formData.append('user[profile_links_attributes]', JSON.stringify(arr))
      formData.append('_method', 'PATCH')
      axios
        .post(`/api/profiles`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const user = data.data.attributes
            this.user = this.filterUserObject(user, this.allowedKeys)
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    filterUserObject (user, allowedKeys) {
      return Object.keys(user)
        .filter((key) => allowedKeys.includes(key))
        .reduce((obj, key) => {
          obj[key] = user[key]
          return obj
        }, {})
    }
  }
}
</script>

<style scoped></style>
